import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import PluginsContainer from '../containers/Plugins';
import cbConnectImage from '../images/C2QB_white_btn_lg_default.png';
import RegistryContainer from '../containers/Registry';

const styles = (theme) => {
	return {
		paper: {
			minHeight : 600,
			width: '100%',
			overflowX: 'auto',
			textAlign : 'left',
			boxSizing: 'border-box',
			padding : 20,
			[theme.breakpoints.up('md')]: {
				padding : '10px 40px 40px 40px',
			}
		},
		connectButton : {
			border : 0,
			backgroundColor : 'none',
			textDecoration: 'none',
			display: 'inline-block',
			margin: 10
		}
	};
};

class Plugins extends Component {

	launchPopup = (path) => {
		let parameters = "location=1,width=800,height=650";
		parameters += ",left=" + (window.innerWidth - 800) / 2 + ",top=" + (window.innerHeight - 650) / 2;
		window.open(path, 'connectPopup', parameters);
	};

	componentDidMount () {
		if (!this.props.registryRows) {
			this.props.searchRegistry({});
		}
	}

	render () {
		const {
			classes,
			registryRows,
			authUser
		} = this.props;

		if (!authUser || !registryRows) {
			return null;
		}

		const quickbooksRegistryRow = _.find(registryRows, {name : 'quickbooksToken'});
		const isConnected = _.isObject(quickbooksRegistryRow);

		let token;
		if (isConnected) {
			token = quickbooksRegistryRow.val;
		}

		return (<Grid container spacing={3}>
			<Grid item xs={12} md={6}>
				<Paper className={classes.paper}>
					{isConnected &&
						<div>
							<div>ALREADY CONNECTED</div>
							<pre>
								{JSON.stringify(token) }
							</pre>
						</div>
					}

					<b>Connect To QuickBooks</b><br />
					<button
						className={classes.connectButton}
						onClick={() => { this.launchPopup('/connectToQuickbooks'); } }
					>
						<img
							alt="Connect to Quickbooks"
							style={{height: 40 }}
							src={cbConnectImage}
						/>
					</button>
				</Paper>
			</Grid>
		</Grid>);
	}
}

Plugins.propTypes = {
	classes: PropTypes.object.isRequired,
	searchRegistry : PropTypes.func,
	registryRows : PropTypes.array,
	authUser : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
	PluginsContainer,
	RegistryContainer,
])(Plugins);
